import React from 'react'

import './Metacritic.css'
const Metacritic = ({ metacritic }) => {
  let score_category = 'poor'
  if (metacritic > 74) score_category = 'good'
  else if (metacritic > 49) score_category = 'fair'
  let score_class = 'metascore metascore_'+ score_category
  return (
    <span className={score_class}>{metacritic}</span>
  )
}

export default Metacritic